import React from "react";
import { Box, Typography, Container, Grid } from "@mui/material";
import { GiDiamondRing, GiPerfumeBottle, GiHandBag } from "react-icons/gi";
import Navbar from "./Navbar";
import Footer from "./Footer";

const About = () => {
  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#000" }}>
      <Navbar />

      <Box
        sx={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundImage: `
            linear-gradient(rgba(10,10,25,0.75), rgba(10,10,25,0.75)),
            url(https://images.unsplash.com/photo-1643237202321-8f8de00975ad?q=80&w=687&auto=format&fit=crop)
          `,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          color: "#fff",
          py: 8,
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h3"
            sx={{ textAlign: "center", fontWeight: 600, mb: 2, letterSpacing: 2 }}
          >
            About RoopShingar
          </Typography>

          <Typography
            variant="h6"
            sx={{ textAlign: "center", color: "#D4AF37", mb: 6, fontWeight: 400 }}
          >
            Luxury Jewellery • Designer Purses • Signature Perfumes
          </Typography>

          <Grid container spacing={6}>
            <Grid item xs={12} md={4} textAlign="center">
              <GiDiamondRing size={50} color="#D4AF37" />
              <Typography variant="h6" sx={{ mt: 2, fontWeight: 600 }}>
                Premium Jewellery
              </Typography>
              <Typography variant="body2" sx={{ mt: 1, color: "#ddd" }}>
                Exquisitely crafted jewellery designed to reflect elegance, sophistication, and timeless beauty.
              </Typography>
            </Grid>

            <Grid item xs={12} md={4} textAlign="center">
              <GiHandBag size={50} color="#D4AF37" />
              <Typography variant="h6" sx={{ mt: 2, fontWeight: 600 }}>
                Designer Purses
              </Typography>
              <Typography variant="body2" sx={{ mt: 1, color: "#ddd" }}>
                Modern, stylish, and luxurious handbags that complement your personality and elevate your look.
              </Typography>
            </Grid>

            <Grid item xs={12} md={4} textAlign="center">
              <GiPerfumeBottle size={50} color="#D4AF37" />
              <Typography variant="h6" sx={{ mt: 2, fontWeight: 600 }}>
                Signature Perfumes
              </Typography>
              <Typography variant="body2" sx={{ mt: 1, color: "#ddd" }}>
                Elegant fragrances crafted to leave a lasting impression and define your presence.
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Footer />
    </Box>
  );
};

export default About;